export default __webpack_public_path__ + "static/media/kitchen4-afterE-768w.d345ccc9.webp";